export const SET_ANSWER = `SET_ANSWER`
export const setAnswer = (question, answerIndex) => ({
    type: SET_ANSWER,
    payload: {question, answerIndex}
})


// WEBPACK FOOTER //
// ./src/actions/answers.js